import Vue from 'vue';
import { AngieUI } from '@fc/angie-ui';
import { config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;

Vue.use(AngieUI, {
  skipCompositionApiInstall: true,
});
